module.exports = __webpack_public_path__ + "img/robot.36a970c8.png";